import { createSelector } from 'reselect';
import { CzasNaDesignStore } from '../store.types';

const callbacksState = (state: CzasNaDesignStore) => state.callbacksState;

export const selectIs_globalToastFailedToFetchActive = createSelector(
  [callbacksState],
  callbacksState => {
    return callbacksState.is_globalToastFailedToFetchActive
  }
);

export const select_is_slideOverlayActive = createSelector(
  [callbacksState],
  callbacksState => {
    return callbacksState.is_slideOverlayActive
  }
);

export const select_is_navbarBarActive = createSelector(
  [callbacksState],
  callbacksState => {
    return callbacksState.is_navbarbarActive
  }
);

export const select_is_navbarOpenActive = createSelector(
  [callbacksState],
  callbacksState => {
    return callbacksState.is_navbarOpenActive
  }
);

export const select_searchPhrase = createSelector(
  [callbacksState],
  callbacksState => {
    return callbacksState.searchPhrase
  }
);